import { PazeFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig, InputType } from "checkout-query-client/types/form-types";

export const pazeFormConfig: FormConfig<PazeFieldNames> = {
  active: true,
  title: "Paze",
  inputs: [
    {
      id: "linkWithPaze",
      type: InputType.linkWithPaze,
      active: true,
    },
  ],
};
